import { gql } from "@apollo/client";

export const GET_TECH_HOURS_ESTIMATE = gql`
  query TechHoursEstimate($start_date: String!, $end_date: String!, $billing_statuses: [String]) {
    techHoursEstimate(start_date: $start_date, end_date: $end_date, billing_statuses: $billing_statuses) {
      total_pages
      estimated_seconds
    }
  }
`;

export const GET_TECH_HOURS_REPORT = gql`
  query TechHoursReport($start_date: String!, $end_date: String!, $billing_statuses: [String]) {
    techHoursReport(start_date: $start_date, end_date: $end_date, billing_statuses: $billing_statuses) {
      user
      start_time
      customer_name
      contact_name
      ticket_number
      actual_time
      billable_time
      billable
      notes
      top_biller_name
      top_biller_time
      invoice_number
      invoice_total
    }
  }
`;
